import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import TextareaAutosize from 'react-autosize-textarea';
import './StatusChangeForm.scss';
var staticText = function staticText(modelName) {
  return "You're about to make a change that affects a live ".concat(modelName, " and its status, outside of the normal workflow. Please make sure to confirm all of the info is correct.");
};
function StatusChangeForm(_ref) {
  var title = _ref.title,
    modelName = _ref.modelName,
    modelOptions = _ref.modelOptions,
    modalStatusOptions = _ref.modalStatusOptions,
    modelSelected = _ref.modelSelected,
    modelStatus = _ref.modelStatus,
    reason = _ref.reason,
    handleInputChange = _ref.handleInputChange,
    submitButtonDisabled = _ref.submitButtonDisabled,
    handleSubmit = _ref.handleSubmit,
    error = _ref.error;
  return /*#__PURE__*/React.createElement("div", {
    className: "status-change-container"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("h4", {
    className: "static-text"
  }, staticText(modelName)), /*#__PURE__*/React.createElement("div", {
    className: "select-input"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "modelSelected"
  }, "Select ".concat(modelName)), /*#__PURE__*/React.createElement(Select, {
    className: "basic-single",
    classNamePrefix: "select",
    defaultValue: modelSelected,
    value: modelSelected,
    isClearable: true,
    isSearchable: true,
    inputId: "modelSelected",
    name: "modelSelected",
    options: modelOptions,
    onChange: function onChange(e) {
      return handleInputChange('modelSelected', e !== null ? e : '');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "select-input"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "modleStatus"
  }, "Select new status"), /*#__PURE__*/React.createElement(Select, {
    className: "basic-single",
    classNamePrefix: "select",
    defaultValue: modelStatus,
    value: modelStatus,
    isClearable: true,
    isSearchable: true,
    inputId: "modelStatus",
    name: "modelStatus",
    options: modalStatusOptions,
    onChange: function onChange(e) {
      return handleInputChange('modelStatus', e !== null ? e : '');
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "textarea-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "reason"
  }, "Change Reason"), /*#__PURE__*/React.createElement(TextareaAutosize, {
    value: reason,
    rows: 3,
    id: "reason",
    name: "reason",
    placeholder: "Enter change reason",
    onChange: function onChange(e) {
      return handleInputChange('reason', e.currentTarget.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "error"
  }, error && error), /*#__PURE__*/React.createElement("div", {
    className: "submit-button"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: submitButtonDisabled ? 'disabled' : 'active',
    onClick: handleSubmit
  }, "Submit")));
}
StatusChangeForm.propTypes = {
  title: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  modelOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  modalStatusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  modelSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })]),
  modelStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })]),
  reason: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitButtonDisabled: PropTypes.bool,
  error: PropTypes.string
};
StatusChangeForm.defaultProps = {
  submitButtonDisabled: false,
  reason: '',
  error: '',
  modelStatus: '',
  modelSelected: ''
};
export default StatusChangeForm;